import { createContext, Dispatch, SetStateAction, useContext } from 'react'
import styled from 'styled-components'

export const PageMaxWidthContext = createContext<
  | {
      maxWidth: string
      setMaxWidth: Dispatch<SetStateAction<string>>
    }
  | undefined
>(undefined)

export const usePageMaxWidth = () => {
  const context = useContext(PageMaxWidthContext)
  if (!context) {
    throw new Error('usePageMaxWidth must be used within a CantileverPage.')
  }
  return context
}

export const MaxWidthEnforcer = styled.div<{ $maxWidth: string }>`
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth};
  margin-left: auto;
  margin-right: auto;
`
